module.exports = __webpack_public_path__ + "vue/img/logo.ad427518.png";